import { SectionContainer } from "../SectionContainer/component";
import InPageNav from "../../../../components/InPageNav/component";
import { PageHeading } from "../../../../components/Heading/component";
import styles from "./styles/themes/default.module.scss";

export default function PageHeadingContainer({
    pageHeading,
    headingVisible,
    description,
    timezoneText,
}) {
    if (!pageHeading) {
        return null;
    }

    // Timezone for schedule pages
    if (timezoneText) {
        description = timezoneText + description;
    }

    return (
        <SectionContainer className={!headingVisible && "noHeading"}>
            <div className={styles.pageHeadingWrapper}>
                <PageHeading
                    hidden={!headingVisible}
                    text={pageHeading}
                    description={description}
                />
                <InPageNav />
            </div>
        </SectionContainer>
    );
}
